import { warmPhonePages, warmTubeHref } from "@/lib/chunk-warm"
import { loadSentryLater, queuedReactErrors } from "@/lib/error-queue"
import { bootInertia } from "@/lib/inertia-boot"
import { resolvePage } from "@/lib/inertia-page-client"
import "@/lib/translate-guard"

import "../entrypoints/application.css"

// Errors are held from the first import; Sentry loads once the page is idle
// and is handed them (lib/error-queue), keeping it out of the shell.
loadSentryLater()

// TangoTube's pages (every host but TangoCloud's; tangocloud.tsx is that one).
bootInertia(resolvePage, queuedReactErrors)

// The page chunk is not part of the JSON prefetch. Warm it from this entry
// so the server render never loads the page graph.
warmPhonePages()

// Intent prefetch loads beside the shell (TT-2179). The shell budget is the
// entry's static imports; this chunk is not one of them.
void import("@/lib/prefetch-intent").then((mod) =>
  mod.installPrefetchIntent(warmTubeHref),
)
